import React, { useState } from "react";
import { useAuth } from "../../Security/AuthProvider"; // Ensure this path is correct
import "./Login.css";
import { useNotification } from '../../Utils/Commons/Notification/NotificationContext';

const Login = () => {
  const [company_name, setCompanyName] = useState("");
  const [company_password, setCompanyPassword] = useState("");
  const { login } = useAuth();
  const { notifyError, notifySuccess } = useNotification();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!company_name || !company_password) {
      notifyError("Veuillez remplir tous les champs");
      return;
    }

    try {
      await login(company_name, company_password);
      notifySuccess('Connexion réussie');
    } catch (err) {
      notifyError(
        err.response?.data?.message || 
        "Une erreur est survenue lors de la connexion. Veuillez réessayer."
      );
    }
  };
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>MONAGORA</h1>
          <div className="underline"></div>
        </div>
        <div className="login-form">
          
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>NOM D'UTILISATEUR</label>
              <input
                type="text"
                value={company_name}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>MOT DE PASSE</label>
              <input
                type="password"
                value={company_password}
                onChange={(e) => setCompanyPassword(e.target.value)}
              />
            </div>
            <div className="button-group">
              <button type="submit" className="login-button">
                SE CONNECTER
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
